import { GridStore, GlobalStore, ApiResponse } from "@roc/feature-app-core";
import { GENERIC_ERROR_MESSAGE } from "@roc/feature-utils";
import { SalesManagementService } from "../../services/salesManagement/salesManagementService";


export class SalesManagementStore {
  globalStore: GlobalStore
  salesManagementGridStore: GridStore;
  outreachOverallGridStore: GridStore;
  journeyBuilderGridStore: GridStore;
  salesManagementService: SalesManagementService;

  outreachDateFrom?: string;
  outreachDateTo?: string;
  businessUnit?: string;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.salesManagementGridStore = new GridStore(() => this.getSalesManagementDashboard(), null, 50);
    this.outreachOverallGridStore = new GridStore(() => this.getOutreachOverallDashboard(), null, 50);
    this.journeyBuilderGridStore = new GridStore(() => this.getJourneyBuilderDashboard(), null, 50);
    this.salesManagementService = new SalesManagementService();
  }

  setOutreachDateRange = (from?: string, to?: string, businessUnit?: string) => {
    this.outreachDateFrom = from;
    this.outreachDateTo = to;
    this.businessUnit = businessUnit

    const meta = this.outreachOverallGridStore.gridData.meta;
    this.outreachOverallGridStore.gridData.meta = {
      ...meta,
      dropdownFilters: {
        ...(meta.dropdownFilters ?? {}),
        dateFrom: from ?? null,
        dateTo: to ?? null,
        businessUnit: businessUnit ?? null
      },
    };
  };

  setBusinessUnit = (businessUnit?: string) => {
    this.businessUnit = businessUnit ?? null
  };

  getSalesManagementDashboard = async () => {
    try {
      const response: ApiResponse = await this.salesManagementService.getSalesManagementGrid(
        this.salesManagementGridStore.gridData.meta.pageNumber,
        this.salesManagementGridStore.gridData.meta.pageSize,
        this.salesManagementGridStore.gridData.meta.sortBy,
        this.salesManagementGridStore.gridData.meta.sortDir,
        this.salesManagementGridStore.gridData.meta.filters,
        this.salesManagementGridStore.gridData.meta.dropdownFilters,
        this.businessUnit
      );
      return response;
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE
      });
    }
  };

  getJourneyBuilderDashboard = async () => {
    try {
      const response: ApiResponse = await this.salesManagementService.getJourneyBuilderGrid(
        this.journeyBuilderGridStore.gridData.meta.pageNumber,
        this.journeyBuilderGridStore.gridData.meta.pageSize,
        this.journeyBuilderGridStore.gridData.meta.sortBy,
        this.journeyBuilderGridStore.gridData.meta.sortDir,
        this.journeyBuilderGridStore.gridData.meta.filters,
        this.journeyBuilderGridStore.gridData.meta.dropdownFilters,
        this.businessUnit
      );
      return response;
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE
      });
    }
  };

  getOutreachOverallDashboard = async () => {
    try {
      const meta = this.outreachOverallGridStore.gridData.meta;

      const dd = {
        ...(meta.dropdownFilters ?? {}),
        dateFrom: this.outreachDateFrom,
        dateTo: this.outreachDateTo,
        businessUnit: this.businessUnit
      };

      const response: ApiResponse = await this.salesManagementService.getOutreachOverallGrid(
        meta.pageNumber,
        meta.pageSize,
        meta.sortBy,
        meta.sortDir,
        meta.filters,
        dd
      );
      return response;
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({ message: GENERIC_ERROR_MESSAGE });
    }
  };


}